/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Button, Select, Tab, Menu } from 'semantic-ui-react';

import { MediaInstagram, MediaFacebook, Loader } from '../../components/share';
import * as AppActions from '../../actions';

import instagramIcon from '../../assets/images/instagram-icon.png';
import facebookIcon from '../../assets/images/facebook-icon.png';

const Container = styled.div`
  overflow-x: hidden;
`;
const Logo = styled.img`
  height: 20px;
  margin-right: 5px;
`;
const NoPreview = styled.div`
  padding: 6px 18px;
  border: 1px solid #969696;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const NoPreviewText = styled.h4`
  color: rgba(0, 0, 0, 0.6);
  margin: 0 !important;
`;
const LoaderContainer = styled.div`
  width: ${(props) => (props.type === 'instagram' ? '250px' : '375px')};
`;
const SelectCustom = styled(Select)`
  width: 375px;
  margin: 10px 0 0;
`;

class AdShareInstagram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instagramList: [],
      facebookList: [],
      pageList: [],
      lobs: {},
      selectedLobId: null,
      tabIndex: 0,
      loading: false
    };
  }

  componentDidMount = async () => {
    await this.props.actions.fetchLob(this.props.user.sub);
  };

  handleTabChange = (e, data) => {
    this.setState({ tabIndex: data.activeIndex });
    this.loadPosts(
      data.panes[data.activeIndex].menuItem.props.accessToken,
      this.state.selectedLobId,
      data.panes[data.activeIndex].menuItem.key,
      data.panes[data.activeIndex].menuItem.props.type
    );
  };

  toAccounts = () => {
    this.props.history.push('/share/settings');
  };

  loadPosts = (access_token, lob_key, account_key, type) => {
    this.props.actions.fetchPost(access_token, lob_key, account_key, type);
  };

  onChangeLob = (selectedLobId) => {
    this.setState({ selectedLobId, tabIndex: 0 });
    this.loadFisrtTabContent(selectedLobId);
  };

  loadFisrtTabContent = (lob_id) => {
    let account = null;
    let account_key = null;

    Object.keys(this.props.adShare.lobs[lob_id].accounts).map((akey, j) => {
      if (j === 0) {
        account_key = akey;
        account = this.props.adShare.lobs[lob_id].accounts[akey];
      }
    });

    if (account)
      this.loadPosts(
        account.access_token,
        account.lob_key,
        account_key,
        account.type
      );
  };

  renderInstagramList = (data, access_token, lob_key, account_key) => {
    if (this.props.adShare.loading) {
      return (
        <LoaderContainer type={this.state.type} className="preview-container">
          <Loader inverted active />
        </LoaderContainer>
      );
    }

    if (data.length === 0) {
      return (
        <div className="preview-container no-previews">
          <NoPreview type={this.state.type}>
            <NoPreviewText>No Instagram Post Setup Yet</NoPreviewText>
          </NoPreview>
          <Button
            onClick={() =>
              this.loadPosts(access_token, lob_key, account_key, 'instagram')
            }
            style={{ marginTop: 20 }}
            secondary
          >
            Load Posts
          </Button>
        </div>
      );
    }

    return (
      <div>
        {data.map((post, i) => (
          <MediaInstagram key={i} item={post} />
        ))}
      </div>
    );
  };

  renderFacebookList = (data, access_token, lob_key, account_key) => {
    if (this.props.adShare.loading) {
      return (
        <LoaderContainer type={this.state.type} className="preview-container">
          <Loader inverted active />
        </LoaderContainer>
      );
    }

    if (data.length === 0) {
      return (
        <div className="preview-container no-previews">
          <NoPreview type={this.state.type}>
            <NoPreviewText>No Facebook Posts Setup Yet</NoPreviewText>
          </NoPreview>
          <Button
            onClick={() =>
              this.loadPosts(access_token, lob_key, account_key, 'facebook')
            }
            style={{ marginTop: 20 }}
            secondary
          >
            Load Posts
          </Button>
        </div>
      );
    }

    return (
      <div>
        {data.map((post, i) => (
          <MediaFacebook key={i} item={post} />
        ))}
      </div>
    );
  };

  renderMedia = (account_key, account) => {
    if (account.type === 'instagram') {
      return this.renderInstagramList(
        account.data,
        account.access_token,
        account.lob_key,
        account_key
      );
    } else if (account.type === 'facebook') {
      return this.renderFacebookList(
        account.data,
        account.access_token,
        account.lob_key,
        account_key
      );
    }

    return null;
  };

  generatePanes = () => {
    let panes = [];
    const { lobs } = this.props.adShare;
    const { selectedLobId } = this.state;

    if (selectedLobId !== null) {
      const { accounts } = lobs[selectedLobId];
      if (accounts && Object.keys(accounts).length > 0) {
        panes = Object.keys(accounts).map((key) => {
          const logo =
            accounts[key].type === 'instagram' ? instagramIcon : facebookIcon;
          return {
            menuItem: (
              <Menu.Item
                key={key}
                accessToken={accounts[key].access_token}
                type={accounts[key].type}
              >
                <Logo
                  src={logo}
                  className="ui"
                  alt={accounts[key].user.username}
                />
                {accounts[key].user.username}
              </Menu.Item>
            ),
            render: () => (
              <Tab.Pane>{this.renderMedia(key, accounts[key])}</Tab.Pane>
            )
          };
        });
      }
    }

    return panes;
  };

  renderSelectLob = () => {
    const { lobs } = this.props.adShare;
    const { selectedLobId } = this.state;

    let options = [];
    if (lobs && Object.keys(lobs).length > 0) {
      options = Object.keys(lobs).map((key) => {
        return { key, value: key, text: lobs[key].name };
      });
    }

    if (options.length > 0) {
      let valueProps = {};

      if (selectedLobId !== null) {
        valueProps.value = selectedLobId;
      }

      return (
        <SelectCustom
          label=""
          options={options}
          placeholder="Line of Business"
          onChange={(ev, data) => this.onChangeLob(data.value)}
          {...valueProps}
          style={{ marginBottom: 30 }}
        />
      );
    }

    return null;
  };

  renderTabs = () => {
    const { lobs } = this.props.adShare;
    const { selectedLobId } = this.state;
    const panes = this.generatePanes();

    if (!(lobs && Object.keys(lobs).length > 0)) {
      return (
        <div className="preview-container no-previews-facebook">
          <NoPreview type={this.state.type}>
            <NoPreviewText>No Lobs Setup Yet</NoPreviewText>
          </NoPreview>
          <Button onClick={this.toAccounts} style={{ marginTop: 20 }} secondary>
            LOB Manager
          </Button>
        </div>
      );
    }

    if (selectedLobId === null) return <div />;

    if (panes.length === 0)
      return (
        <div className="preview-container no-previews-facebook">
          <NoPreview type={this.state.type}>
            <NoPreviewText>No Accounts Setup Yet</NoPreviewText>
          </NoPreview>
          <Button onClick={this.toAccounts} style={{ marginTop: 20 }} secondary>
            Manage Accounts
          </Button>
        </div>
      );

    return (
      <Tab
        panes={panes}
        activeIndex={this.state.tabIndex}
        onTabChange={this.handleTabChange}
      />
    );
  };

  render() {
    return (
      <Container className="container">
        <h3>Constellation Test</h3>
        {this.renderSelectLob()}
        {this.renderTabs()}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adShare: state.adShare
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdShareInstagram);



// WEBPACK FOOTER //
// ./src/screens/AdShare/Instagram.js